/**
 * Состояние навигации, с которым на «Устройства» приходят с кнопки «Ссылка на табло для OBS»
 * в карточке матча. Раньше эта кнопка открывала превью табло со ссылкой по матчу; теперь
 * ссылка принадлежит устройству, поэтому страница по этому флагу объясняет, что изменилось.
 */
export interface DevicesNavigationState {
  fromMatchOverlay?: boolean;
}

export const fromMatchOverlayState: DevicesNavigationState = { fromMatchOverlay: true };
